import { useEffect, useState, useCallback } from "react";
import { useMatter } from "../../contexts/MatterContext";
import NoMatterView from "../../components/NoMatterView";
import LoadingView from "../../components/LoadingView";
import ErrorView from "../../components/ErrorView";
import { Heading } from "../../design/heading";
import { VisitationScheduleUpsellCard } from "./components/VisitationScheduleUpsellCard";
import { useVisitationSchedule } from "../../contexts/VisitationScheduleContext";
import EmptyStateView from "../../components/EmptyStateView";
import { useNavigate } from "react-router-dom";
import { Button } from "../../design/button";
import CreateVisitationScheduleButton from "../../components/CreateVisitationScheduleButton/CreateVisitationScheduleButton";
import { Link } from "../../design/link";
import { CustodyTimeline } from "../../components/CustodyTimeline";
import { useParticipant } from "../../contexts/ParticipantContext";

const VisitationSchedulePage = () => {
  const {
    currentMatterId,
    currentMatter,
    loading: loadingMatter,
  } = useMatter();
  const { participants } = useParticipant();
  const { currentVisitationSchedule, loading, error } = useVisitationSchedule();
  const navigate = useNavigate();

  if (!currentMatterId) return <NoMatterView />;
  if (loadingMatter.list) return <LoadingView title="Loading Matter" />;
  if (loading.list) return <LoadingView title="Loading Visitation Schedule" />;
  if (error.list) return <ErrorView error={error.list} />;

  const hasVisitationFeature = currentMatter?.unlockedFeatures?.includes(
    "visitation_schedule_tracker",
  );

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <Heading>Visitation Schedule</Heading>
        <div className="flex items-center gap-2">
          {hasVisitationFeature && (
            <CreateVisitationScheduleButton
              onSave={(id) => navigate(`/visitation-schedule/${id}`)}
            />
          )}
          {hasVisitationFeature && currentVisitationSchedule && (
            <Button
              onClick={() =>
                navigate(
                  `/visitation-schedule/${currentVisitationSchedule._id}`,
                )
              }
            >
              Edit Current Schedule
            </Button>
          )}
        </div>
      </div>

      {!hasVisitationFeature && <VisitationScheduleUpsellCard />}

      {hasVisitationFeature && !currentVisitationSchedule && (
        <EmptyStateView
          title="No Visitation Schedule Found"
          message="It seems like there are no visitation schedules available for this matter."
          action={
            <CreateVisitationScheduleButton
              onSave={(id) => navigate(`/visitation-schedule/${id}`)}
            />
          }
        />
      )}
      {hasVisitationFeature && currentVisitationSchedule && (
        <div className="overflow-hidden bg-white rounded shadow">
          <CustodyTimeline
            rotation={currentVisitationSchedule.rotation}
            startDate={currentVisitationSchedule.startDate}
            participants={participants}
          />
        </div>
      )}
      {
        <div className="flex items-center justify-center gap-4">
          <Link
            href={`/visitation-schedules`}
            className="text-sm font-medium text-blue-600 hover:underline"
          >
            View Other Schedules
          </Link>
        </div>
      }
    </div>
  );
};

export default VisitationSchedulePage;
